<template>
  <div class="historyPage">
    <div class="title">{{$t('lang.setting.myHistory')}}</div>
    <div class="historyContainer"
         v-infinite-scroll="fetchHistory"
         :infinite-scroll-disabled="hasLoadAll"
         v-if="historyList.length"
    >
      <div class="historyItem" v-for="(item, index) in historyList" :key="index">
        <div class="time">{{item.TransactionDate}}</div>
        <div class="content">
          <div class="contentLeft">
            <div class="name">
              <div v-if="item.Type==='Bet'||item.Type==='Win'">{{item.GameNameEn}}</div>
              <img v-if="item.Type==='Deposit'||item.Type==='Withdrawal'" :src="item.Type==='deposit'?deposit:withdraw" alt="">
            </div>
            <div class="type">{{item.Type}}</div>
          </div>
          <div class="contentRight">
            <div class="amount">{{plusOrMinus(item.Type)}} {{fetchCurrency[currency]}}{{separateThousand(item.Amount)}}</div>
            <div class="status">
              {{$t('lang.setting.status')}}
              <span :style="statusColor(item.Status)">{{item.Status}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomLogo" v-if="hasLoadAll && historyList.length">
        <img :src="logo" alt="">
      </div>
    </div>
    <div class="empty" v-if="!historyList.length && skipNum">
      - -
    </div>
  </div>
</template>

<script>
import request from '@/service'
import {separateThousand} from '@/utils'
import {fetchCurrency} from '@/constant'
import deposit from '@/assets/images/common/deposit.svg'
import withdraw from '@/assets/images/common/withdraw.svg'
import logo from '@/assets/images/common/logo1.svg'
export default {
  name: 'History',
  data () {
    return {
      count: 0,
      skipNum: 0,
      takeNum: 10,
      date: 7,
      type: 'total',
      historyList: [],
      hasLoadAll: false,
      currency: JSON.parse(localStorage.getItem('userInfo')).CurrencyName,
      fetchCurrency,
      deposit,
      withdraw,
      separateThousand,
      logo
    }
  },
  computed: {
    statusColor () {
      return (status) => {
        switch (status) {
          case 'done':
            return {color: '#20E200'}
          case 'rejected':
            return {color: '#FF2828'}
          default:
            return {color: '#686868'}
        }
      }
    }
  },
  mounted () {
    this.fetchHistory()
  },
  methods: {
    fetchHistory () {
      const url = '/innovation/transactions/history'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        skip: this.skipNum,
        take: this.takeNum,
        date: this.date,
        type: this.type
      }
      request('post', url, data).then(res => {
        console.log(res)
        this.historyList = this.historyList.concat(res.Transactions)
        this.skipNum += this.takeNum
        this.hasLoadAll = this.skipNum >= res.Total
      })
    },
    plusOrMinus (type) {
      switch (type) {
        case 'bet':
        case 'withdrawal':
          return '-'
        case 'win':
        case 'deposit':
          return '+'
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .historyPage {
    height: 100%;
    .title {
      font-family: Roboto-Medium, sans-serif;
      font-size: 22px;
      line-height: 26px;
      color: #F6D9AA;
      font-weight: 500;
      margin-bottom: 30px;
    }
    .historyContainer {
      height: 456px;
      overflow: auto;
      padding-right: 10px;
      padding-top: 5px;
      .historyItem {
        padding: 14px 24px 10px 20px;
        background: #3D3D3D;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
        border-radius: 6px;
        margin-bottom: 20px;
        .time {
          font-size: 12px;
          line-height: 14px;
          color: #fff;
        }
        .content {
          display: flex;
          .contentLeft {
            flex: 3;
            border-right: 1px solid #000000;
            .name {
              height: 40px;
              font-size: 24px;
              line-height: 40px;
              color: #F6D9AA;
              div {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              img {
                margin-top: 5px;
              }
            }
            .type {
              width: max-content;
              font-size: 12px;
              line-height: 20px;
              color: #fff;
              background-color: #0A0A0A;
              border-radius: 16px;
              padding: 0 13px;
            }
          }
          .contentRight {
            flex: 1;
            text-align: right;
            .amount {
              font-size: 18px;
              line-height: 21px;
              color: #F6D9AA;
              margin-bottom: 5px;
            }
            .status {
              font-size: 10px;
              line-height: 12px;
              color: #ffffff;
              display: flex;
              flex-direction: column;
              span {
                font-size: 14px;
                line-height: 16px;
              }
            }
          }
        }
      }
      .bottomLogo {
        text-align: right;
        img {
          width: 40px;
        }
      }
      &::-webkit-scrollbar {
        width: 1px;
        height: 100%;
      }
      &::-webkit-scrollbar-track {
        width: 1px;
        height: 100%;
        background-color: transparent;
        border-radius: 33px;
      } /* 滚动条的滑轨背景颜色 */
      &::-webkit-scrollbar-thumb {
        width: 1px;
        border-radius: 33px;
        background-color: #F6D9AA;
      } /* 滑块颜色 */
    }
    .empty {
      padding: 20px;
      color: #686868;
      text-align: center;
      background: #272727;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
      border-radius: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/History/index.vue